import Cookies from 'js-cookie'

const TokenKey = 'yiihuu_sso'

const TokenNick = "nick"
export function getToken() {

  return Cookies.get(TokenKey)
  return "743e9fae9c0b52a922f7cd3c1b6df258abe07d35"
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}


export function getNick() {
  return Cookies.get(TokenNick)
  return "用户名"
}

export function setNick(name) {
  return Cookies.set(TokenNick, name)
}

export function removeNick() {
  return Cookies.remove(TokenNick)
}

